import type { RepairReasonResponse } from '@/lib/service/ecs/contracts';

export interface RepairReasonLabel {
  label: string;
  value: string;
}

export function formatRepairReasons(
  reasonCodes: string[],
  catalogue: RepairReasonResponse['items'] | undefined
): RepairReasonLabel[] {
  if (!reasonCodes.length) return [];

  if (catalogue?.length) {
    return reasonCodes.map((code) => {
      const match = catalogue.find((item) => item.code === code);
      return { label: match?.title ?? code, value: code };
    });
  }

  return reasonCodes.map((code) => ({ label: code, value: code }));
}
